export default "__VITE_PUBLIC_ASSET__55181367__"